import AddIcon from '@mui/icons-material/Add'
import Button, { ButtonProps } from '@mui/material/Button'
import React from 'react'

type Props = ButtonProps

const CreateButton: React.FC<Props> = ({
  children,
  color = 'primary',
  startIcon = <AddIcon />,
  variant = 'contained',
  ...props
}) => (
  <Button color={color} startIcon={startIcon} variant={variant} {...props}>
    {children}
  </Button>
)

export default CreateButton
